const subheadingsData = {
  1: [
    {
      title: "About Me",
      content: (
        <>
          <p style={{backgroundColor: "black", textTransform: "uppercase", color: "white", fontSize: "5xl", fontWeight: "bolder"}}>
            Hey, I'm Amjad. I am a FULL STACK DEVELOPER (MERN). I am a website developer from DUBAI.I used  html5 css3,Javascript,Typescript, nodejs, express js,mongodb. I create professional websites. As a web developer, I have a passion for creating dynamic and engaging online experiences.
          </p>
        </>
      ),
    },
  ],
  2: [
    {
      title: "2022-2024 Pathway Software Engineer program",
      content: (
        <>
          <p style={{backgroundColor: "black", color: "white", fontSize: "5xl", fontWeight: "bolder"}}>
            Programming Languages List the languages you are proficient in JavaScript, TypeScript, C#, React.js, Node.js, Express.js, MongoDB. Focus on experiences related to pathway software or similar projects.
          </p>
        </>
      ),
    },
    {
      title: "2020 Higher School Certificate",
      content: (
        <>
          <p style={{backgroundColor: "black", color: "white", fontSize: "5xl", fontWeight: "bolder"}}>
            HSC- Higher school Certificate Diploma From Bangladeshi Collage.A Level programs in Bangladesh can vary based on several factors, including individual student preferences, teaching quality, and assessment styles.
          </p>
        </>
      ),
    },
  ],
  3: [
    {
      title: "2024(6 Month) Salesman",
      content: (
        <>
          <p style={{backgroundColor: "black", color: "white", fontSize: "5xl", fontWeight: "bolder"}}>
            See rock Computer Trading LLC.Earphones,Charger,Extention are main item Sales experience represents your history of selling products or services to other people. Gaining sales experience also helps you develop various soft skills, such as communication, listening, negotiation and problem-solving. 
          </p>
        </>
      ),
    },
    {
      title: "Web designer 8 month (Html Css and Figma)",
      content: (
        <>
          <p style={{ backgroundColor: "black", color: "white", fontSize: "5xl", fontWeight: "bolder"}}>
            Sama Al Madina Services.I have a design background and a general understanding of coding. I know html and css and get JS but haven't done much JS.So I get everything in terms of design, but I am wondering what the process is like once the design is complete and I want to have it coded? This is the part that I don't understand and don't really know specifically what to search for.
          </p>
        </>
      ),
    }, 
    {
      title: "2021-2023 (1.9 year) Salesperson",
      content: (
        <>
          <p style={{ backgroundColor: "black", color: "white", fontSize: "5xl", fontWeight: "bolder"}}>
            Malaber Al Lail Project Management Salesperson.Sales experience represents your history of selling products or services to other people. Gaining sales experience also helps mine develop various soft skills, such as communication, listening, negotiation and problem-solving. 
          </p>
        </>
      ),
    },
  ],
};

export default subheadingsData;
